'use client';

import { useEffect } from 'react';

/**
 * Locale is cookie-based (localePrefix: "never"), so the root layout — which
 * sits above the [locale] segment — cannot know the active locale without
 * opting the whole app into dynamic rendering. This syncs <html lang> on the
 * client instead, so Chinese pages don't announce themselves as English to
 * screen readers and crawlers executing JS.
 */
export default function HtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    const lang = locale === 'zh' ? 'zh-CN' : locale;
    if (document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [locale]);

  return null;
}
